// extracted by mini-css-extract-plugin
export default {"loadingContainer":"NotfnDetails_loadingContainer__RhOTV"};